import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import copy from 'copy-to-clipboard';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FilterNoneIcon from '@material-ui/icons/FilterNone';

// STORE
import { NotifActions } from '@/store/actions';

// HOOKS
import useActions from '@/hooks/useActions';

// STYLES
import Container from './styles';

const ClickToCopy = ({ children, copyText, withoutCopy, message, tooltipTitle }) => {
  const [t] = useTranslation();
  const [isCopied, setCopied] = useState(false);

  const [pushNotification] = useActions([
    () =>
      NotifActions.pushNotification.action({
        message,
        options: {
          variant: 'success',
        },
      }),
  ]);

  if (withoutCopy) return children;

  const handleCopyClick = e => {
    if (e) e.stopPropagation();

    copy(copyText);

    if (message) pushNotification();

    setCopied(true);
  };

  const handleMouseLeave = () => {
    setTimeout(() => {
      setCopied(false);
    }, 400);
  };

  return (
    <Container className="click-to-copy" onMouseLeave={handleMouseLeave} onClick={handleCopyClick}>
      <Tooltip
        title={
          <div className="cursor cursor--pointer" aria-hidden="true" onClick={handleCopyClick}>
            {tooltipTitle ?? t(`common.${isCopied ? 'linkCopied' : 'copyLink'}`)}
          </div>
        }
        interactive
      >
        <div className="click-to-copy__content">
          {children}
          <IconButton className="click-to-copy__icon">
            <FilterNoneIcon />
          </IconButton>
        </div>
      </Tooltip>
    </Container>
  );
};

ClickToCopy.defaultProps = {
  withoutCopy: false,
};

ClickToCopy.propTypes = {
  children: PropTypes.node,
  copyText: PropTypes.string,
  withoutCopy: PropTypes.bool,
  message: PropTypes.string,
  tooltipTitle: PropTypes.string,
};

export default React.memo(ClickToCopy);
